import styled from 'styled-components';

export const VideoModalStyles = styled.div`
  .modal {
    display: block;
    background: rgba(45, 50, 59, 0.8);
    .modal-body {
      padding: 0;
    }
  }
`;
